const focusHeader = (contentId = "reach-skip-nav") => {
    const mainContent = document.querySelector(`#${contentId}`);
    if (mainContent) {
        mainContent.focus();
    }
};

export default focusHeader;
